<template>
  <div class="row align-items-center form-group" :class="classes">
    <div class="col-12 col-md-2">
      <label :for="id" class="control-label">
        {{ label }}
      </label>
    </div>
    <div class="col-12 col-md-3">
      <v-select v-if="isIE"
                :options="hubsIE"
                :placeholder="$t('multiselect.placeholder')"
                :id="id"
                multiple
                track-by="id"
                v-model="valueIE"
                @input="onChangeIE" />

      <multiselect v-else
                   :placeholder="$t('multiselect.placeholder')"
                   :hide-selected="true"
                   :multiple="true"
                   :options="hubs"
                   :showLabels="false"
                   :id="id"
                   label="name"
                   track-by="id"
                   @input="onChange"
                   v-model="values" />
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ie_mixin from '@/mixin/ie'

export default {
  name: 'SelectHub',
  components: { Multiselect },
  mixins: [ie_mixin],
  data() {
    return {
      values: [],
    }
  },
  props: {
    hubs: Array,
    selectedIds: { type: Array, default: () => [] },
    label: { type: String, default: 'pôle' },
    id: { type: String, default: 'hub' },
  },
  mounted() {
    this.initValue();
  },
  computed: {
    classes() {
      return {
        'form-group-ie': this.isIE,
        'form-multiselect': !this.isIE,
      }
    },
    hubsIE() {
      return this.hubs.map(hub => hub.name)
    }
  },
  methods: {
    initValue() {
      this.values = this.hubs.filter(hub => this.selectedIds.includes(hub.id))
    },
    onChangeIE(valuesIE) {
      this.values = this.searchValuesInArray(valuesIE, this.hubs)
      this.$emit('change', this.values)
    },
    onChange(values) {
      this.$emit('change', values)
    },
  },
  watch: {
    selectedIds: function() {
      this.initValue();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SelectHub.vue